import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  title() {
    return faker.lorem.words(3);
  },

  startDate() {
    return faker.date.between(
      '2020-01-01T00:00:00.000Z',
      '2021-01-01T00:00:00.000Z',
    );
  },

  endDate() {
    return faker.date.between(
      '2021-01-01T00:00:00.001Z',
      '2022-01-01T00:00:00.000Z',
    );
  },

  deleteDate() {
    return faker.date.between(
      '2022-01-01T00:00:00.001Z',
      '2023-01-01T00:00:00.000Z',
    );
  },

  ctaButton() {
    return faker.lorem.words(3);
  },

  confirmationText() {
    return `<p>${faker.lorem.sentence()}</p>`;
  },

  keepWinners() {
    return faker.datatype.boolean();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(collection, server) {
    let numFormFiels = faker.datatype.number({
      min: 1,
      max: 3,
    });

    collection.update({
      formFields: server.createList('contest-form-field', numFormFiels),
    });
  },
});
